/**
 * SuspenseLoader - Instant loading skeleton for Suspense boundaries
 * 
 * PERFORMANCE: Shows immediately (no delay) to improve FCP/LCP metrics.
 * A blank screen during loading hurts Core Web Vitals significantly.
 */

interface SuspenseLoaderProps {
  /** @deprecated - No longer used. Keeping for backwards compatibility. */
  delay?: number;
}

export function SuspenseLoader(_props: SuspenseLoaderProps) {
  // Show skeleton IMMEDIATELY - no delay
  // This improves FCP by showing content right away
  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="flex flex-col items-center gap-4">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
        <p className="text-sm text-muted-foreground animate-pulse">Loading...</p>
      </div>
    </div>
  );
}
